<div class="custom-dropdown">
    <!-- Dropdown Trigger Button -->
    <button class="dropdown-trigger"
            #dropdownTrigger
            [disabled]="disabled || loading"
            [class.disabled]="disabled || loading"
            [class.loading]="loading"
            [class.open]="isOpen"
            (click)="toggleDropdown()"
            [title]="loading ? 'Loading...' : getDisplayValue()">
        <span class="dropdown-value">
            {{ loading ? 'Loading...' : getDisplayValue() }}
        </span>
        <div class="spinner-mini" *ngIf="loading"></div>
        <span class="material-icons dropdown-arrow" *ngIf="!loading">arrow_drop_down</span>
    </button>

    <!-- Dropdown Menu -->
    <div class="dropdown-menu" *ngIf="isOpen && !disabled" [@slideDown]>
        <!-- No Options Message -->
        <div *ngIf="options?.length === 0" class="dropdown-no-options">
            <span class="no-options-text">No supported documents</span>
        </div>
        
        <!-- Options List -->
        <button *ngFor="let option of options"
                class="dropdown-option"
                [class.selected]="isOptionSelected(option)"
                (click)="selectOption(option)">
            <span class="option-text">{{ option }}</span>
            <span class="material-icons check-icon" *ngIf="isOptionSelected(option)">check</span>
        </button>
    </div>
</div>
